import { ImpostazioniGenerali } from 'app/model/impostazioni_generali';
import { ColoreEvento, IColoreEvento } from 'app/model/colore_evento';

import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-options',
	templateUrl: './opzioni.html',
	styleUrls: ['./opzioni.css']
})

export class OptionsComponent {

	isLogin: boolean = false;

	constructor(
		public activeModal: NgbActiveModal,
		public impostazioni: ImpostazioniGenerali
	) { }

	update(evento: ColoreEvento, newValue: IColoreEvento) {
		evento.update(Object.assign({}, newValue));
	}

}



// WEBPACK FOOTER //
// ./src/app/opzioni/opzioni.ts